const eraseCookie = (name) => {   
  document.cookie = name+'=; Max-Age=-99999999;';  
}

const handleButton = (button) => {
  let current_favorites = Cookies.getJSON('favorite_apartments');
  let cookie_data = Cookies.getJSON('favorite_apartments');
  // If there's multiple buttons for same apartment (ie. singulars)
  let buttons_to_be_handed = document.querySelectorAll('button[data-id="' + button.getAttribute('data-id') +'"]');
  for (const _button of buttons_to_be_handed) {
    if (!_button.classList.contains('disabled')) {
      let data_id = _button.getAttribute('data-id');
      let data_variation = _button.getAttribute('data-variation');
      if (current_favorites !== undefined && current_favorites[data_id] !== undefined) {
        if (current_favorites[data_id].data_variation === data_variation && !_button.classList.contains('selected')) {
          _button.classList.add('selected');
        }
      } else { 
        _button.classList.remove('selected'); 
      }
    } else { 
      //_button.classList.remove('selected'); 
      removeFavorite(button, cookie_data);
      Cookies.set('favorite_apartments', JSON.stringify(cookie_data), { expires: 30, samesite: 'None', secure: true });
      handleCounts();
      handleGotoApplicationLinks();
      handleHistoryState();
    }
  } 
}

const addCountToCountItems = () => {
  function hasCount(parent) {
    for (const child of parent.children) {
      if (child.classList.contains('favorite-apartments-count')) {
        return true;
      }
    }
    return false;
  }

  let parent_elements = document.querySelectorAll('.js-favorite-apartments-count-parent');
  const count_wrapper = document.createElement("div");
  count_wrapper.classList.add('favorite-apartments-count');
  const count_span = document.createElement("span");
  count_span.classList.add('favorite-apartments-count__number');
  count_span.classList.add('js-favorite-apartments-count');
  count_wrapper.appendChild(count_span);

  for (const parent_element of parent_elements) {
      if (parent_element.querySelector('a') !== null) {
        if (!hasCount(parent_element.querySelector('a'))) {
          parent_element.querySelector('a').appendChild(count_wrapper.cloneNode(true));
        }
      } else {
        if (!hasCount(parent_element)) {
          parent_element.appendChild(count_wrapper.cloneNode(true));  
        }
      }
  }

  handleCounts();
}

const handleCounts = () => {
  let count_elements = document.querySelectorAll('.js-favorite-apartments-count');
  let cookie_data = Cookies.getJSON('favorite_apartments');

  let count = cookie_data ? Object.keys(cookie_data).length : 0;
  for (const count_element of count_elements) {

    if (cookie_data !== undefined && count > 0) {
      count_element.innerHTML = count;
      let aria_label = 'Toivelistaan valittu ' + count;
      if (count === 1) {
        aria_label += ' asunto';
      } else {
        aria_label += ' asuntoa';
      }
      count_element.setAttribute('aria-label', aria_label);
      count_element.parentElement.style.display = 'flex';
    } else {
      count_element.parentElement.style.display = 'none';
    }
  }
}

const handleFavorites = (button) => {
  let data_id = button.getAttribute('data-id');
  let data_variation = button.getAttribute('data-variation');
  let cookie_data = Cookies.getJSON('favorite_apartments');
  
  if (cookie_data === undefined) {
    cookie_data = {};
  }
  
  if (data_id in cookie_data) {
    cookie_data = removeFavorite(button, cookie_data);
  } else {
    cookie_data[data_id] = {
      'data_variation' : data_variation
    };
  }
  
  Cookies.set('favorite_apartments', JSON.stringify(cookie_data), { expires: 30, samesite: 'None', secure: true });
  handleButton(button);
  handleCounts();
  handleGotoApplicationLinks();
  handleHistoryState();
}

const removeFavorite = (button, cookie_data) => {
  let data_id = button.getAttribute('data-id');
  delete cookie_data[data_id];

  let _GET = window.location.search.toString();
  if (_GET.includes('favorite_apartments')) {
    let apartment_card = button.parentElement.parentElement;
    apartment_card.style.opacity = 0;
    apartment_card.style.transform = 'translateY(-.5rem)';
    setTimeout(function() {
      button.parentElement.parentElement.remove();
    }, 500)
  }

  return cookie_data;
}

const getGotoApplicationUrl = (original_url) => {
  // Favorite apartments to url parameters
  let cookie_data = Cookies.getJSON('favorite_apartments');
  let apartments_url_param = '';
  if (cookie_data !== undefined && Object.entries(cookie_data).length) {
    for (const [key, value] of Object.entries(cookie_data)) {
      if (apartments_url_param === '') {
        apartments_url_param = '?favorite_apartments[]=' + key + '-' + value.data_variation;
      } else {
        apartments_url_param += '&favorite_apartments[]=' + key + '-' + value.data_variation;
      }
    }
  } else {
    apartments_url_param = '?favorite_apartments[]';
  }
  return original_url + apartments_url_param;
}

const handleHistoryState = () => {
  let _GET = window.location.search.toString();
  if (_GET.includes('favorite_apartments')) {
    history.replaceState(null, '', getGotoApplicationUrl(hae_asuntoa_page));
  }
}

const handleGotoApplicationLinks = () => {
  let form = document.querySelector('#gform_1');
  if (form !== undefined && form !== null) {
    let current_action = form.getAttribute('action');
    form.setAttribute('action', getGotoApplicationUrl(hae_asuntoa_page));
  }
  for (const item of document.querySelectorAll('[href*="' + hae_asuntoa_page +'"]')) {
    item.setAttribute('href', getGotoApplicationUrl(hae_asuntoa_page));
  }
}

window.addEventListener('DOMContentLoaded', () => {
  addCountToCountItems();
  for (const favorites_button of document.querySelectorAll('.js-favorites-button')) {
    handleButton(favorites_button);
  }
  handleGotoApplicationLinks();
});

window.addEventListener('click', function(e) {
  if (e.target.classList.contains('js-favorites-button') && !e.target.classList.contains('disabled')) {
    handleFavorites(e.target);
  }
});